"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
interface DesktopOnlyProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}
export function DesktopOnly(t0) {
  const $ = _c(2);
  const {
    children,
    fallback: t1
  } = t0;
  const fallback = t1 === undefined ? null : t1;
  const [isDesktop, setIsDesktop] = useState(false);
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const mediaQuery = window.matchMedia("(min-width: 1024px)");
      setIsDesktop(mediaQuery.matches);
      const handler = e => setIsDesktop(e.matches);
      mediaQuery.addEventListener("change", handler);
      return () => mediaQuery.removeEventListener("change", handler);
    };
    t3 = [];
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  useEffect(t2, t3);
  if (!isDesktop) {
    return fallback;
  }
  return children;
}